var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"siglesources",attrs:{"id":"select-siglesource"}},[_c('Select2',{ref:"select2",attrs:{"settings":_vm.selectConfig,"tabindex":"0"},on:{"select":function($event){return _vm.select($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }